angular.module('cvsApp').factory('possibleDeliveryDateServiceModel',['commonModel',function(CM) {	
	'use strict';
	var possibleDeliveryDateServiceModel = function(){

		var self = this;

		self.apiResponse = {};
		
		this.setResponse = function(data){
			setApiResponse(data);
			// CM.setResponse(data);
		};	

		this.getResponse = function(){
			// self.apiResponse = CM.getResponse() || '';
			// self.header = getHeader();
            if(getHeader().statusCode === "0000" || getHeader().statusCode === "DBPL0000"){

            }
            else {
            	self.showError = getHeader();
			}
			return self;		
		};

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		};

		this.getError = function(){
			if(self.showError){
				return self.showError;
			}
			return "";
		};

		var setApiResponse = function (data) {
			var jsonRes = cvsUtility.xmlToJSON(data);
			if(jsonRes && jsonRes.hasOwnProperty('possibleDeliveryDatesResponse')){
				self.headers = jsonRes.possibleDeliveryDatesResponse.header;
				self.apiResponse = jsonRes.possibleDeliveryDatesResponse.details;
			}


		};

		var getHeader = function () {
			return self.headers;
		};
	
	};
	
	return new possibleDeliveryDateServiceModel();
}]);